import { useAuthStore } from '@/stores/auth.store'
import { createRoute, redirect } from '@tanstack/react-router'
import { Route as rootRoute } from './__root'

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => {
    const isAuth = useAuthStore.getState().isAuthenticated
    // /home runs inside <WorkspaceProvider> and resolves to the user's
    // current workspace home_path (or falls back to /dashboard).
    throw redirect({ to: isAuth ? '/home' : '/auth/login' })
  },
  component: () => null,
})
